var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedWidget.type === "static-text"
    ? _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.textAlign") } },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "radio-group-custom",
              model: {
                value: _vm.optionModel.textAlign,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "textAlign", $$v)
                },
                expression: "optionModel.textAlign",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "left" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.i18nt("designer.setting.leftAlign"))
                ),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "center" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.i18nt("designer.setting.centerAlign"))
                ),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "right" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.i18nt("designer.setting.rightAlign"))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }